import React, { Component } from "react";
import axios from "axios";

// Estilos personalizados para los indicadores de paso
const customStyles = `
    .bg-purple {
        background-color: #8B5CF6 !important;
    }
    .text-purple {
        color: #8B5CF6 !important;
    }
`;

class TwoFactorAuth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: false,
            qrCode: null,
            secret: null,
            verificationCode: '',
            showSetup: false,
            currentStep: 1, // 1 = Escanear QR, 2 = Verificar, 3 = Mostrar códigos de recuperación
            loading: false,
            message: '',
            messageType: 'success', // 'success' or 'error'
            recoveryCodes: [], // Array of recovery codes
            showRecoveryCodes: false, // Whether to show recovery codes modal/section
            showRecoveryCodeInput: false, // Whether to show recovery code input for disabling 2FA
            recoveryCode: '', // Recovery code input for disabling 2FA
            focusedInputIndex: 0, // Keep track of which input field is currently focused
            enabledAt: null, // Fecha en la que se habilitó 2FA
            enabledAtFormatted: '', // Texto formateado que indica cuando se habilitó 2FA
            description: '' // Texto que indica la descripción
        };
        
        this.generateSecret = this.generateSecret.bind(this);
        this.enableMfa = this.enableMfa.bind(this);
        this.disableMfa = this.disableMfa.bind(this);
        this.disableMfaWithRecoveryCode = this.disableMfaWithRecoveryCode.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDigitChange = this.handleDigitChange.bind(this);
        this.cancelSetup = this.cancelSetup.bind(this);
        this.goToVerificationStep = this.goToVerificationStep.bind(this);
        this.goBackToQrStep = this.goBackToQrStep.bind(this);
        this.closeRecoveryCodes = this.closeRecoveryCodes.bind(this);
        this.downloadRecoveryCodes = this.downloadRecoveryCodes.bind(this);
        this.generateRecoveryCodes = this.generateRecoveryCodes.bind(this);
    }

    componentDidMount() {
        this.loadMfaStatus();
    }

    loadMfaStatus() {
        axios.get("/mfa/status").then((response) => {
            if (response.data.success) {
                this.setState({
                    enabled: response.data.enabled,
                    enabledAt: response.data.enabled_at,
                    enabledAtFormatted: response.data.enabled_at_formatted
                });
            }
        }).catch(error => {
            console.error("Error fetching MFA status:", error);
        });
    }

    generateSecret() {
        this.setState({ loading: true, message: '' });
        
        axios.post("/mfa/generate-secret")
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        secret: response.data.secret,
                        qrCode: response.data.qr_code,
                        showSetup: true,
                        currentStep: 1,
                        loading: false,
                        message: ''
                    });
                } else {
                    this.setState({ 
                        loading: false,
                        message: response.data.message || 'Error al generar el secreto para 2FA',
                        messageType: 'error'
                    });
                }
            })
            .catch((error) => {
                this.setState({ 
                    loading: false,
                    message: error.response?.data?.message || 'Error al generar el secreto para 2FA',
                    messageType: 'error'
                });
            });
    }

    enableMfa() {
        this.setState({ loading: true, message: '' });
        
        console.log('Enviando verificación con código:', this.state.verificationCode);
        axios.post("/mfa/enable", {
            token: this.state.verificationCode
        })
            .then((response) => {
                console.log('Respuesta completa del servidor:', response.data);
                
                if (response.data.success === true) {
                    console.log('Verificación exitosa, códigos de recuperación:', response.data.recovery_codes);
                    this.setState({
                        verificationCode: '',
                        enabled: true,
                        loading: false,
                        message: response.data.message || 'Autenticación de dos factores activada exitosamente',
                        description: response.data.description || 'Tu cuenta ahora está protegida con autenticación de dos factores. Necesitarás tu aplicación autenticadora para futuros inicios de sesión.',
                        messageType: 'success',
                        currentStep: 3,
                        recoveryCodes: response.data.recovery_codes || [],
                        showRecoveryCodes: true
                    });
                    
                    // Notify parent component
                    if (this.props.onStatusChange) {
                        this.props.onStatusChange(true);
                    }
                } else {
                    this.setState({ 
                        loading: false,
                        message: response.data.message || 'Error al verificar el código',
                        messageType: 'error'
                    });
                }
            })
            .catch((error) => {
                this.setState({ 
                    loading: false,
                    message: error.response?.data?.message || 'Error al verificar el código',
                    messageType: 'error'
                });
            });
    }

    disableMfa() {
        this.setState({ loading: true, message: '' });
        
        axios.post("/mfa/disable", {
            token: this.state.verificationCode
        })
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        enabled: false,
                        loading: false,
                        showSetup: false,
                        verificationCode: '',
                        qrCode: null,
                        secret: null,
                        message: 'Autenticación de dos factores desactivada exitosamente',
                        messageType: 'success'
                    });
                    
                    // Notify parent component
                    if (this.props.onStatusChange) {
                        this.props.onStatusChange(false);
                    }
                } else {
                    this.setState({ 
                        loading: false,
                        message: response.data.message || 'Error al verificar el código',
                        messageType: 'error'
                    });
                }
            })
            .catch((error) => {
                this.setState({ 
                    loading: false,
                    message: error.response?.data?.message || 'Error al verificar el código',
                    messageType: 'error'
                });
            });
    }
    
    disableMfaWithRecoveryCode() {
        this.setState({ loading: true, message: '' });
        
        axios.post("/mfa/disable-with-recovery", {
            recovery_code: this.state.recoveryCode
        })
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        enabled: false,
                        loading: false,
                        showSetup: false,
                        recoveryCode: '',
                        showRecoveryCodeInput: false,
                        qrCode: null,
                        secret: null,
                        message: 'Autenticación de dos factores desactivada exitosamente con código de recuperación',
                        messageType: 'success'
                    });
                    
                    // Notify parent component
                    if (this.props.onStatusChange) {
                        this.props.onStatusChange(false);
                    }
                } else {
                    this.setState({ 
                        loading: false,
                        message: response.data.message || 'Código de recuperación inválido o ya utilizado',
                        messageType: 'error'
                    });
                }
            })
            .catch((error) => {
                this.setState({ 
                    loading: false,
                    message: error.response?.data?.message || 'Error al verificar el código de recuperación',
                    messageType: 'error'
                });
            });
    }

    handleInputChange(e) {
        // Only allow numeric input and limit to 6 digits
        const value = e.target.value.replace(/[^0-9]/g, '').substring(0, 6);
        this.setState({ verificationCode: value, message: '' });
    }
    
    handleDigitChange(e, position) {
        // Solo permitir números
        const value = e.target.value.replace(/[^0-9]/g, '');
        
        if (value) {
            // Construir el nuevo código completo
            const currentCode = this.state.verificationCode;
            const newCode = currentCode.substring(0, position) + value + currentCode.substring(position + 1);
            
            this.setState({ verificationCode: newCode.substring(0, 6), message: '' }, () => {
                // Auto-focus en el siguiente input si hay valor y no estamos en el último
                if (value && position < 5) {
                    const nextInput = e.target.parentNode.querySelector(`input:nth-child(${position + 2})`);
                    if (nextInput) {
                        nextInput.focus();
                    }
                }
            });
        } else {
            // Si se borró el valor, actualizar el código
            const currentCode = this.state.verificationCode;
            const newCode = currentCode.substring(0, position) + currentCode.substring(position + 1);
            
            this.setState({ verificationCode: newCode, message: '' });
        }
    }

    cancelSetup() {
        this.setState({
            showSetup: false,
            verificationCode: '',
            qrCode: null,
            secret: null,
            currentStep: 1,
            message: ''
        });
    }

    goToVerificationStep() {
        this.setState({
            currentStep: 2,
            verificationCode: '',
            message: ''
        });
    }

    goBackToQrStep() {
        this.setState({
            currentStep: 1,
            verificationCode: '',
            message: ''
        });
    }

    closeRecoveryCodes() {
        this.setState({
            showRecoveryCodes: false,
            showSetup: false,
            currentStep: 1
        });
        
        // Refresh MFA status
        this.loadMfaStatus();
    }
    
    // Esta función ha sido reemplazada por el formato desde el backend

    downloadRecoveryCodes() {
        // Prepare recovery codes as plain text
        const text = this.state.recoveryCodes.join('\n');
        
        // Create a blob
        const blob = new Blob([text], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        
        // Create a link element and trigger download
        const a = document.createElement('a');
        a.href = url;
        a.download = '2fa-recovery-codes-exppedify.txt';
        document.body.appendChild(a);
        a.click();
        
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
    
    generateRecoveryCodes() {
        this.setState({ loading: true, message: '' });
        
        axios.post('/mfa/generate-recovery-codes')
            .then(response => {
                if (response.data.success) {
                    this.setState({
                        recoveryCodes: response.data.recovery_codes,
                        showRecoveryCodes: true,
                        loading: false,
                        message: 'Se han generado nuevos códigos de recuperación',
                        messageType: 'success'
                    });
                } else {
                    this.setState({
                        loading: false,
                        message: response.data.message || 'Error al generar códigos de recuperación',
                        messageType: 'error'
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    message: error.response?.data?.message || 'Error al generar códigos de recuperación',
                    messageType: 'error'
                });
            });
    }

    render() {
        return (
            <>
                {/* Aplicar estilos personalizados para los colores púrpura */}
                <style>{customStyles}</style>
            <div className="card card-custom">
                <div className="card-header py-5">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark"> 
                            Autenticación de Dos Factores (2FA)
                        </h3>
                        <span className="text-muted mt-1 font-weight-bold font-size-sm">
                            Agrega una capa adicional de seguridad a tu cuenta. Puedes usar Google Authenticator, Microsoft Authenticator, Authy, etc.
                        </span>
                    </div>
                </div>
                <div className="card-body">
                    {this.state.message && (
                        <div className={`alert alert-${this.state.messageType === 'success' ? 'success' : 'danger'} mb-4`}>
                            {this.state.messageType === 'success' ? 
                            <>
                                <div>
                                    <h4 className="alert-heading mb-1">
                                    <svg className="mr-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21.8006 9.99999C22.2573 12.2413 21.9318 14.5714 20.8785 16.6018C19.8251 18.6322 18.1075 20.24 16.0121 21.1573C13.9167 22.0746 11.5702 22.2458 9.36391 21.6424C7.15758 21.0389 5.2248 19.6974 3.88789 17.8414C2.55097 15.9854 1.89073 13.7272 2.01728 11.4434C2.14382 9.15952 3.04949 6.98808 4.58326 5.29116C6.11703 3.59424 8.18619 2.47442 10.4457 2.11844C12.7052 1.76247 15.0184 2.19185 16.9996 3.33499" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 11L12 14L22 4" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {this.state.message}
                                    </h4>
                                    <p className="mb-0">{this.state.description}</p>
                                </div>
                            </>: 
                            <>
                                <svg className="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8C14.6668 4.3181 11.6821 1.33333 8.00016 1.33333C4.31826 1.33333 1.3335 4.3181 1.3335 8C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 5.33333V8" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 10.6667H8.00667" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                {this.state.message}
                                </>
                            } 
                        </div>
                    )}

                    {/* MFA Status */}
                    {(!this.state.showSetup && !this.state.enabled) && <>
                        <div className="d-flex flex-column mb-4">
                         
                        <div className="flex-grow-1">
                            
                            <p className="text-muted mb-0 mt-1">
                            Agrega una capa adicional de seguridad a tu cuenta. Puedes usar aplicaciones como Google Authenticator, Microsoft Authenticator, Authy, etc.
                            </p>
                        </div>
                        <div className="mt-3 alert alert-warning" style={{backgroundColor: '#FFF3CD', color: '#92400E'}}>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex">
                                                <svg className="mr-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                    <path d="M18.109 15L11.4423 3.33333C11.297 3.07684 11.0862 2.86349 10.8314 2.71506C10.5767 2.56662 10.2872 2.48842 9.99234 2.48842C9.69752 2.48842 9.40797 2.56662 9.15324 2.71506C8.8985 2.86349 8.6877 3.07684 8.54234 3.33333L1.87567 15C1.72874 15.2545 1.6517 15.5433 1.65235 15.8371C1.653 16.1309 1.73132 16.4194 1.87938 16.6732C2.02744 16.927 2.23996 17.1372 2.49542 17.2824C2.75088 17.4276 3.04018 17.5026 3.33401 17.5H16.6673C16.9598 17.4997 17.2469 17.4225 17.5001 17.2761C17.7532 17.1297 17.9634 16.9192 18.1094 16.6659C18.2555 16.4126 18.3324 16.1253 18.3323 15.8329C18.3322 15.5405 18.2552 15.2532 18.109 15Z" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 7.5V10.8333" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 14.1667H10.0083" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <p className="mb-2"><strong>2FA está actualmente DESHABILITADO</strong></p>
                                                </div>
                                                <div>
                                                   
                                                    <p className="mb-0  ">
                                                    Tu cuenta es vulnerable a accesos no autorizados. Te recomendamos habilitar la autenticación de dos factores.
                                                    </p>
                                                </div>
                                            </div> 
                        {!this.state.enabled && !this.state.showSetup && (
                            <button 
                                type="button" 
                                className="btn btn-primary mt-3"
                                onClick={this.generateSecret}
                                disabled={this.state.loading}
                            >
                                {this.state.loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                                        Cargando...
                                    </>
                                ) : (
                                    <>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 9.75C15 13.5 12.375 15.375 9.255 16.4625C9.09162 16.5179 8.91415 16.5152 8.7525 16.455C5.625 15.375 3 13.5 3 9.75V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75C5.25 3.75 7.125 2.85 8.43 1.71C8.58889 1.57425 8.79102 1.49966 9 1.49966C9.20898 1.49966 9.41111 1.57425 9.57 1.71C10.8825 2.8575 12.75 3.75 14.25 3.75C14.4489 3.75 14.6397 3.82902 14.7803 3.96967C14.921 4.11032 15 4.30109 15 4.5V9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.75 9H11.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 6.75V11.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Habilitar 2FA
                                    </>
                                )}
                            </button>
                        )}
                        </div>
                    </div>
                    </>}


                    {/* Setup Process - Only show steps when not enabled and showing setup */}
                    {!this.state.enabled && this.state.showSetup && (
                        <div className="mt-4">
                            {/* Step Indicators - Diseño actualizado */}
                            <div className="d-flex align-items-center mb-4" style={{margin:'0 auto', width:'40%'}}>
                                {/* Paso 1 - Escanear QR */}
                                <div className="d-flex align-items-center">
                                    <div 
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${this.state.currentStep === 1 ? 'bg-purple' : (this.state.currentStep > 1 ? 'bg-success' : 'bg-light')}`} 
                                        style={{width: '40px', height: '40px'}}
                                    >
                                        {this.state.currentStep > 1 ? 
                                            <i className="fas fa-check text-white"></i> : 
                                            <span className={`${this.state.currentStep === 1 ? 'text-white' : 'text-secondary'} font-weight-bold`}>1</span>
                                        }
                                    </div>
                                    <div className="ml-2">
                                        <span 
                                            className={`${this.state.currentStep === 1 ? 'text-purple' : (this.state.currentStep > 1 ? 'text-success' : 'text-secondary')} font-weight-bold`}
                                        >
                                            Escanear QR
                                        </span>
                                    </div>
                                </div>
                                
                                {/* Línea conectora */}
                                <div 
                                    className={`flex-grow-1 ${this.state.currentStep > 1 ? 'bg-success' : 'bg-secondary'}`} 
                                    style={{height: '2px', margin: '0 15px'}}
                                ></div>
                                
                                {/* Paso 2 - Verificar */}
                                <div className="d-flex align-items-center">
                                    <div 
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${this.state.currentStep === 2 ? 'bg-purple' : (this.state.currentStep > 2 ? 'bg-success' : 'bg-light')}`} 
                                        style={{width: '40px', height: '40px'}}
                                    >
                                        {this.state.currentStep > 2 ? 
                                            <i className="fas fa-check text-white"></i> : 
                                            <span className={`${this.state.currentStep === 2 ? 'text-white' : 'text-muted'} font-weight-bold`}>2</span>
                                        }
                                    </div>
                                    <div className="ml-2">
                                        <span 
                                            className={`${this.state.currentStep === 2 ? 'text-purple' : (this.state.currentStep > 2 ? 'text-success' : 'text-muted')} font-weight-bold`}
                                        >
                                            Verificar
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Step 1 - QR Code Scanning */}
                            {this.state.currentStep === 1 && (
                                <div className="row">
                                    {/* QR Code Column */}
                                    <div className="col-md-6 border-right">
                                        <h5 className="mb-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 18H12.01" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Configurar Aplicación Autenticadora
                                        </h5>
                                        
                                        {this.state.qrCode && (
                                            <div className="text-center p-3 bg-light rounded mb-3" style={{borderRadius: '8px'}}>
                                                {/* Si es una URL o base64 completo */}
                                                {this.state.qrCode.startsWith('data:image') || this.state.qrCode.startsWith('http') ? (
                                                    <img src={this.state.qrCode} alt="Código QR" className="img-fluid" />
                                                ) : (
                                                    /* Si es HTML */
                                                    <div dangerouslySetInnerHTML={{ __html: this.state.qrCode }} />
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {/* Instructions Column */}
                                    <div className="col-md-6">
                                        <h5 className="mb-3">Configuración Manual</h5> 
                                        {this.state.secret && (
                                            <div className="mb-4 p-3 rounded" style={{
                                                background: '#6366F1',
                                                color: 'white'
                                            }}>
                                                <label className="font-weight-bold mb-1">Clave Secreta:</label>
                                                <div className="d-flex align-items-center">
                                                    <input 
                                                   
                                                        type="text" 
                                                        className="form-control back-purple border-0" 
                                                        value={this.state.secret} 
                                                        readOnly
                                                    />
                                                    <button 
                                                    
                                                        type="button"
                                                        className="btn back-purple btn-light ml-2"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(this.state.secret);
                                                            alert('Código copiado al portapapeles');
                                                        }}
                                                        title="Copiar código"
                                                    >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_15867_5889)">
                                                        <path d="M13.334 5.33334H6.66732C5.93094 5.33334 5.33398 5.93029 5.33398 6.66667V13.3333C5.33398 14.0697 5.93094 14.6667 6.66732 14.6667H13.334C14.0704 14.6667 14.6673 14.0697 14.6673 13.3333V6.66667C14.6673 5.93029 14.0704 5.33334 13.334 5.33334Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M2.66732 10.6667C1.93398 10.6667 1.33398 10.0667 1.33398 9.33334V2.66667C1.33398 1.93334 1.93398 1.33334 2.66732 1.33334H9.33398C10.0673 1.33334 10.6673 1.93334 10.6673 2.66667" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_15867_5889">
                                                        <path d="M0 0H16V16H0V0Z" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        )} 
                                       
                                    </div>
                                    <div className="col-md-12">
                                    <div className="alert alert-warning" style={{backgroundColor: '#FFF3CD', color: '#92400E'}}>
                                            <div className="d-flex">
                                                <div>
                                                <svg className="mr-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                    <path d="M18.109 15L11.4423 3.33333C11.297 3.07684 11.0862 2.86349 10.8314 2.71506C10.5767 2.56662 10.2872 2.48842 9.99234 2.48842C9.69752 2.48842 9.40797 2.56662 9.15324 2.71506C8.8985 2.86349 8.6877 3.07684 8.54234 3.33333L1.87567 15C1.72874 15.2545 1.6517 15.5433 1.65235 15.8371C1.653 16.1309 1.73132 16.4194 1.87938 16.6732C2.02744 16.927 2.23996 17.1372 2.49542 17.2824C2.75088 17.4276 3.04018 17.5026 3.33401 17.5H16.6673C16.9598 17.4997 17.2469 17.4225 17.5001 17.2761C17.7532 17.1297 17.9634 16.9192 18.1094 16.6659C18.2555 16.4126 18.3324 16.1253 18.3323 15.8329C18.3322 15.5405 18.2552 15.2532 18.109 15Z" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 7.5V10.8333" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 14.1667H10.0083" stroke="#F59E0B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                </div>
                                                <div>
                                                    <p className="mb-2"><strong>Aplicaciones Recomendadas:</strong></p>
                                                    <ul className="mb-0 pl-3">
                                                        <li>Google Authenticator</li>
                                                        <li>Microsoft Authenticator</li>
                                                        <li>Authy</li>
                                                    </ul>
                                                </div>
                                            </div>
                                    </div>
                                        
                                        <div className="text-right mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary mr-2"
                                                onClick={this.cancelSetup}
                                            >
                                                Cancelar
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn btn-primary"
                                                onClick={this.goToVerificationStep}
                                            >
                                                <i className="fas fa-arrow-right mr-2"></i>
                                                Continuar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Step 2 - Code Verification */}
                            {this.state.currentStep === 2 && (
                                <div className="text-center" style={{width: '70%', margin: '0 auto'}}>
                                    <div style={{marginBottom: '30px', marginTop: '30px'}}>
                                    <svg style={{width: '44px', height: '44px'}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                         <path d="M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0203 11.67 21.94C7.5 20.5 4 18 4 13V5.99999C4 5.73478 4.10536 5.48042 4.29289 5.29289C4.48043 5.10535 4.73478 4.99999 5 4.99999C7 4.99999 9.5 3.79999 11.24 2.27999C11.4519 2.09899 11.7214 1.99954 12 1.99954C12.2786 1.99954 12.5481 2.09899 12.76 2.27999C14.51 3.80999 17 4.99999 19 4.99999C19.2652 4.99999 19.5196 5.10535 19.7071 5.29289C19.8946 5.48042 20 5.73478 20 5.99999V13Z" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 12L11 14L15 10" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <h3 className="text-dark font-weight-bold mb-3">Verificar tu aplicación</h3>
                                    
                                    <div className="mb-5">
                                        <p className="text-muted mb-5">Ingresa el código de 6 dígitos que aparece en tu aplicación autenticadora</p>
                                        
                                        <div className="mb-5">
                                            <h5 className="text-left font-weight-bold text-dark mb-3">Código de verificación:</h5>
                                            <div className="d-flex justify-content-between mb-3" style={{width: '55%', margin: '0 auto'}}>
                                            {/* Demo values for each field - '7', '3', '9', '2', '6', '' */}
                                            {[0, 1, 2, 3, 4, 5].map((index) => {
                                                // Demo values for visualization
                                                const demoValues = ['', '', '', '', '', ''];
                                                const demoValue = index < 5 ? demoValues[index] : '';
                                                
                                                return (
                                                <div key={index} className="mx-1" style={{width: '40px'}}>
                                                    <input
                                                        type="text"
                                                        className="form-control text-center"
                                                        style={{
                                                            width: '40px', 
                                                            height: '40px', 
                                                            fontSize: '24px', 
                                                            fontWeight: '600',
                                                            borderWidth: '1px',
                                                            borderColor: index === this.state.focusedInputIndex ? '#7E22CE' : '#e4e6ef',
                                                            borderRadius: '8px',
                                                            backgroundColor: 'white',
                                                            boxShadow: index === this.state.focusedInputIndex ? '0 0 0 0.2rem rgba(126, 34, 206, 0.25)' : 'none'
                                                        }}
                                                        onFocus={() => this.setState({ focusedInputIndex: index })}
                                                        value={this.state.verificationCode[index] || demoValue}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, '');
                                                            if (value.length <= 1) {
                                                                const newCode = this.state.verificationCode.split('');
                                                                newCode[index] = value;
                                                                const finalCode = newCode.join('').slice(0, 6);
                                                                this.setState({
                                                                    verificationCode: finalCode,
                                                                    message: ''
                                                                });
                                                                
                                                                // Auto-focus next input
                                                                if (value && index < 5) {
                                                                    const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
                                                                    if (nextInput) {
                                                                        nextInput.focus();
                                                                        this.setState({ focusedInputIndex: index + 1 });
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            // Handle backspace to go to previous input
                                                            if (e.key === 'Backspace' && !this.state.verificationCode[index] && index > 0) {
                                                                const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
                                                                if (prevInput) {
                                                                    prevInput.focus();
                                                                    this.setState({ focusedInputIndex: index - 1 });
                                                                }
                                                            }
                                                        }}
                                                        maxLength="1"
                                                        autoFocus={index === 0}
                                                        data-index={index}
                                                    />
                                                </div>
                                                );
                                            })}
                                            </div>
                                        </div>
                                    
                                        {/* Warning Message */}
                                        <div className="alert mb-5" style={{backgroundColor: '#FEF9C3', borderColor: '#FEF08A', borderWidth: '1px', borderRadius: '12px', padding: '16px'}}>
                                            <div className="d-flex align-items-start">
                                                <svg className="mr-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                    <path d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z" stroke="#CA8A04" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                <div className="text-left">
                                                    <strong className="text-amber-700">¿No ves el código?</strong>
                                                    <p className="mb-0 mt-1 text-amber-700">
                                                        Asegúrate de que la hora en tu dispositivo esté sincronizada. Los códigos se actualizan cada 30 segundos.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="d-flex justify-content-between mt-5">
                                        <button 
                                            type="button" 
                                            className="btn btn-light btn-lg px-5 py-2"
                                            onClick={this.goBackToQrStep}
                                            disabled={this.state.loading}
                                            style={{borderRadius: '8px', fontWeight: '500'}}
                                        >
                                            <svg className="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            Atrás
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-lg px-5 py-2"
                                            onClick={this.enableMfa}
                                            disabled={this.state.loading || this.state.verificationCode.length !== 6}
                                            style={{
                                                backgroundColor: '#7E22CE', 
                                                color: 'white', 
                                                borderRadius: '8px', 
                                                fontWeight: '500', 
                                                borderColor: '#7E22CE'
                                            }}
                                        >
                                            {this.state.loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                                                    Verificando...
                                                </>
                                            ) : (
                                                <>
                                                    Verificar y Habilitar
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                                                        <path d="M15 9.75C15 13.5 12.375 15.375 9.255 16.4625C9.09162 16.5179 8.91415 16.5152 8.7525 16.455C5.625 15.375 3 13.5 3 9.75V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75C5.25 3.75 7.125 2.85 8.43 1.71C8.58889 1.57425 8.79102 1.49966 9 1.49966C9.20898 1.49966 9.41111 1.57425 9.57 1.71C10.8825 2.8575 12.75 3.75 14.25 3.75C14.4489 3.75 14.6397 3.82902 14.7803 3.96967C14.921 4.11032 15 4.30109 15 4.5V9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M6.75 9H11.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M9 6.75V11.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Recovery Codes - Show whenever codes are available, independent of enabled/setup state */}
                    {this.state.showRecoveryCodes && (
                                <div className="text-center">
                                     {/* Header with Success Icon */}
                                     <div className="text-center mt-4 mb-4">
                                         <div className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-4" style={{width: '100px', height: '100px'}}>
                                             <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M24.0003 4L9.00027 10V22C9.00027 32.94 15.3603 43.14 24.0003 46C32.6403 43.14 39.0003 32.94 39.0003 22V10L24.0003 4Z" stroke="#7E22CE" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                                 <path d="M17.7002 24L22.5002 28.8L30.3002 21" stroke="#7E22CE" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                             </svg>
                                         </div>
                                         <h4 className="font-weight-bold text-dark mb-2">¡2FA Habilitado Exitosamente!</h4>
                                         <p className="text-muted">
                                             Tu cuenta ahora está protegida con autenticación de dos factores
                                         </p>
                                     </div>

                                    {/* Recovery Codes Section */}
                                    <div className="card bg-light mb-4">
                                        
                                        <div className="card-body">
                                            <p className="mb-3 text-dark">
                                                <strong>IMPORTANTE: Descarga y guarda estos códigos en un lugar seguro.</strong> Si pierdes acceso a tu aplicación de autenticación, necesitarás uno de estos códigos para iniciar sesión.
                                            </p> 
                                        </div>
                                        <div className="card-footer d-flex justify-content-between">
                                            <button 
                                                type="button" 
                                                className="btn btn-primary btn-lg"
                                                onClick={this.downloadRecoveryCodes}
                                            >
                                                <i className="fas fa-download mr-2"></i>
                                                <strong>Descargar Códigos de Recuperación</strong>
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn btn-success"
                                                onClick={this.closeRecoveryCodes}
                                            >
                                                <i className="fas fa-check mr-2"></i>
                                                He Guardado los Códigos
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                    {/* MFA Enabled View */}
                    {this.state.enabled == true && (
                        <>
                            {/* Success banner */} 
                            {/* Main 2FA Management Section */}
                            <div className="card mb-4 border-0 shadow-sm">
                                <div className="card-header bg-white">
                                    <h5 className="mb-0">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        
        <path d="M12.22 2H11.78C11.2496 2 10.7409 2.21071 10.3658 2.58579C9.99072 2.96086 9.78 3.46957 9.78 4V4.18C9.77964 4.53073 9.68706 4.87519 9.51154 5.17884C9.33602 5.48248 9.08374 5.73464 8.78 5.91L8.35 6.16C8.04596 6.33554 7.70108 6.42795 7.35 6.42795C6.99893 6.42795 6.65404 6.33554 6.35 6.16L6.2 6.08C5.74107 5.81526 5.19584 5.74344 4.684 5.88031C4.17217 6.01717 3.73555 6.35154 3.47 6.81L3.25 7.19C2.98526 7.64893 2.91345 8.19416 3.05031 8.706C3.18717 9.21783 3.52154 9.65445 3.98 9.92L4.13 10.02C4.43228 10.1945 4.68362 10.4451 4.85905 10.7468C5.03448 11.0486 5.1279 11.391 5.13 11.74V12.25C5.1314 12.6024 5.03965 12.949 4.86405 13.2545C4.68844 13.5601 4.43521 13.8138 4.13 13.99L3.98 14.08C3.52154 14.3456 3.18717 14.7822 3.05031 15.294C2.91345 15.8058 2.98526 16.3511 3.25 16.81L3.47 17.19C3.73555 17.6485 4.17217 17.9828 4.684 18.1197C5.19584 18.2566 5.74107 18.1847 6.2 17.92L6.35 17.84C6.65404 17.6645 6.99893 17.5721 7.35 17.5721C7.70108 17.5721 8.04596 17.6645 8.35 17.84L8.78 18.09C9.08374 18.2654 9.33602 18.5175 9.51154 18.8212C9.68706 19.1248 9.77964 19.4693 9.78 19.82V20C9.78 20.5304 9.99072 21.0391 10.3658 21.4142C10.7409 21.7893 11.2496 22 11.78 22H12.22C12.7504 22 13.2591 21.7893 13.6342 21.4142C14.0093 21.0391 14.22 20.5304 14.22 20V19.82C14.2204 19.4693 14.3129 19.1248 14.4885 18.8212C14.664 18.5175 14.9163 18.2654 15.22 18.09L15.65 17.84C15.954 17.6645 16.2989 17.5721 16.65 17.5721C17.0011 17.5721 17.346 17.6645 17.65 17.84L17.8 17.92C18.2589 18.1847 18.8042 18.2566 19.316 18.1197C19.8278 17.9828 20.2645 17.6485 20.53 17.19L20.75 16.8C21.0147 16.3411 21.0866 15.7958 20.9497 15.284C20.8128 14.7722 20.4785 14.3356 20.02 14.07L19.87 13.99C19.5648 13.8138 19.3116 13.5601 19.136 13.2545C18.9604 12.949 18.8686 12.6024 18.87 12.25V11.75C18.8686 11.3976 18.9604 11.051 19.136 10.7455C19.3116 10.4399 19.5648 10.1862 19.87 10.01L20.02 9.92C20.4785 9.65445 20.8128 9.21783 20.9497 8.706C21.0866 8.19416 21.0147 7.64893 20.75 7.19L20.53 6.81C20.2645 6.35154 19.8278 6.01717 19.316 5.88031C18.8042 5.74344 18.2589 5.81526 17.8 6.08L17.65 6.16C17.346 6.33554 17.0011 6.42795 16.65 6.42795C16.2989 6.42795 15.954 6.33554 15.65 6.16L15.22 5.91C14.9163 5.73464 14.664 5.48248 14.4885 5.17884C14.3129 4.87519 14.2204 4.53073 14.22 4.18V4C14.22 3.46957 14.0093 2.96086 13.6342 2.58579C13.2591 2.21071 12.7504 2 12.22 2Z" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#844AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
                                        Gestionar Autenticación de Dos Factores
                                    </h5>
                                    <p className="text-muted mb-0">Administra tu configuración de seguridad y códigos de respaldo.</p>
                                </div>

                                <div className="card-body">
                                    {/* Status Section */}
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-success rounded-circle p-2 mr-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0203 11.67 21.94C7.5 20.5 4 18 4 13V5.99999C4 5.73478 4.10536 5.48042 4.29289 5.29289C4.48043 5.10535 4.73478 4.99999 5 4.99999C7 4.99999 9.5 3.79999 11.24 2.27999C11.4519 2.09899 11.7214 1.99954 12 1.99954C12.2786 1.99954 12.5481 2.09899 12.76 2.27999C14.51 3.80999 17 4.99999 19 4.99999C19.2652 4.99999 19.5196 5.10535 19.7071 5.29289C19.8946 5.48042 20 5.73478 20 5.99999V13Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9 12L11 14L15 10" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div>
                                                <span className="text-muted small">Estado actual</span>
                                                <h6 className="mb-0">2FA Habilitado</h6>
                                            </div>
                                        </div>
                                        <span className="text-muted small">{this.state.enabledAtFormatted}</span>
                                    </div>

                                    {/* Recovery Codes Section */}
                                    <div className="d-flex align-items-center justify-content-between border-top pt-3">
                                        <div className="d-flex align-items-center">
                                        <svg className="mr-3" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
 
<path d="M12.916 6.25L14.8327 8.16667C14.9885 8.31936 15.1979 8.40488 15.416 8.40488C15.6341 8.40488 15.8436 8.31936 15.9993 8.16667L17.7493 6.41667C17.902 6.2609 17.9876 6.05146 17.9876 5.83334C17.9876 5.61521 17.902 5.40578 17.7493 5.25L15.8327 3.33334" stroke="#6B7280" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 1.66666L9.5 9.66666" stroke="#6B7280" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.24935 17.5C8.78065 17.5 10.8327 15.448 10.8327 12.9167C10.8327 10.3854 8.78065 8.33334 6.24935 8.33334C3.71804 8.33334 1.66602 10.3854 1.66602 12.9167C1.66602 15.448 3.71804 17.5 6.24935 17.5Z" stroke="#6B7280" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                                            <div>
                                                <h6 className="mb-1">Códigos de respaldo</h6>
                                                <p className="text-muted small mb-0">Guarda estos códigos en un lugar seguro. Puedes usarlos si pierdes acceso a tu aplicación autenticadora.</p>
                                            </div>
                                        </div>
                                        <button 
                                            className="btn btn-primary" 
                                            onClick={this.generateRecoveryCodes}
                                        >
                                            Generar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Danger Zone */}
                            <div className="card border-danger mb-4">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <i className="fas fa-exclamation-triangle text-danger mr-2"></i>
                                        <h5 className="text-danger mb-0">Zona de peligro</h5>
                                    </div>
                                    <p className="text-danger">Deshabilitar la autenticación de dos factores hará que tu cuenta sea menos segura.</p>
                                    
                                    <p>Para deshabilitar 2FA, ingresa un código de tu aplicación autenticadora:</p>
                                    
                                    <div className="d-flex align-items-center mt-3">
                                        <div className="d-flex flex-grow-1">
                                            {/* Code inputs */}
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(0) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 0)}
                                                style={{width: '50px'}} 
                                            />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(1) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 1)}
                                                style={{width: '50px'}} 
                                            />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(2) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 2)}
                                                style={{width: '50px'}} 
                                            />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(3) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 3)}
                                                style={{width: '50px'}} 
                                            />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(4) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 4)}
                                                style={{width: '50px'}} 
                                            />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-lg text-center mx-1" 
                                                maxLength="1" 
                                                value={this.state.verificationCode.charAt(5) || ''}
                                                onChange={(e) => this.handleDigitChange(e, 5)}
                                                style={{width: '50px'}} 
                                            />
                                        </div>
                                        
                                        <button 
                                            type="button" 
                                            className="btn btn-danger ml-3"
                                            onClick={this.disableMfa}
                                            disabled={this.state.loading || this.state.verificationCode.length !== 6}
                                        >
                                            {this.state.loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                                                    Procesando...
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                    Deshabilitar 2FA
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <div className="mt-4">
                                        <p className="mb-2">¿Perdiste tu dispositivo autenticador?</p>
                                        <button 
                                            type="button" 
                                            className="btn btn-link text-danger p-0"
                                            onClick={() => this.setState({ showRecoveryCodeInput: !this.state.showRecoveryCodeInput })}
                                        >
                                            <i className="fas fa-key mr-1"></i> Deshabilitar 2FA usando código de recuperación
                                        </button>
                                    </div>
                                    
                                    {this.state.showRecoveryCodeInput && (
                                        <div className="mt-3 border-top pt-3">
                                            <div className="form-group">
                                                <label>Código de recuperación:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Ingresa tu código de recuperación"
                                                    value={this.state.recoveryCode || ''}
                                                    onChange={(e) => this.setState({ recoveryCode: e.target.value })}
                                                />
                                                <small className="form-text text-muted">
                                                    Ingresa uno de los códigos de recuperación que guardaste cuando activaste 2FA.
                                                </small>
                                            </div>
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-danger mt-2"
                                                onClick={this.disableMfaWithRecoveryCode}
                                                disabled={this.state.loading || !this.state.recoveryCode}
                                            >
                                                <i className="fas fa-shield-alt mr-1"></i> Deshabilitar 2FA
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            </>
        );
    }
}

export default TwoFactorAuth;
